"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityModule = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const jwt_1 = require("@nestjs/jwt");
const typeorm_1 = require("@nestjs/typeorm");
const entity_service_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/entity-service.utils");
const notification_utils_1 = require("../../../../service-lib/src/lib/utils/notification.utils");
const auth_guard_1 = require("../../../../auth-service/src/guards/auth.guard"); // Import AuthGuard here
const role_guard_1 = require("../../../../auth-service/src/guards/role.guard"); // Import RolesGuard here
const address_module_1 = require("../../../../org-service/src/app/address/address.module");
const look_up_module_1 = require("../../../../org-service/src/app/look-up/look-up.module");
const employee_module_1 = require("../../../../org-service/src/app/employee/employee.module");
const entities_1 = require("../../../../service-lib/src/lib/entities");
const lookup_validation_1 = require("../../../../service-lib/src/lib/utils/lookup-validation");
const meeting_module_1 = require("../meeting/meeting.module");
const scope_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/scope.utils");
const task_module_1 = require("../task/task.module");
const opportunity_controller_1 = require("./opportunity.controller");
const opportunity_repository_1 = require("./opportunity.repository");
const opportunity_service_1 = require("./opportunity.service");
let OpportunityModule = class OpportunityModule {
};
exports.OpportunityModule = OpportunityModule;
exports.OpportunityModule = OpportunityModule = tslib_1.__decorate([
    (0, common_1.Module)({
        imports: [
            typeorm_1.TypeOrmModule.forFeature([
                entities_1.Opportunity,
                entities_1.OpportunityRiskLocations,
                entities_1.OpportunityDocuments,
                entities_1.OpportunityCompetitors,
                entities_1.OpportunityClaimExperiences,
                entities_1.OpportunityChallenges,
                entities_1.OpportunityActivityMap,
                entities_1.OpportunityActivityParticipants,
                entities_1.LookUp,
                entities_1.User,
                entities_1.DataValidation,
                entities_1.Meeting,
                entities_1.KdmMeeting,
                entities_1.OpportunityHandOverMeet,
                entities_1.MstrActivity,
                entities_1.OpportunityMandateDetailsDocumentMap,
                entities_1.OpportunityMandateDetailsEntry,
                entities_1.OpportunityMandateDetailsContactMap,
                entities_1.OpportunityRfpCoverDetail,
                entities_1.OpportunityCoverMap,
                entities_1.OpportunityRfpDetail,
                entities_1.OpportunityRfpActivityDocumentMap,
                entities_1.Task,
                entities_1.OpportunityQuoteEntry,
                entities_1.OpportunityQuoteEntryDocumentMap,
                entities_1.OpportunityRfpDetailsEntry,
                entities_1.OpportunityRfpTpaDetail,
                entities_1.OpportunityRfpInsurerDetail,
                entities_1.OpportunityRfpCreditSharing,
                entities_1.OpportunityRfpClientContactDetail,
                entities_1.OpportunityRfpClientContactInfluencers,
                entities_1.OpportunityRfpDetailsEntryDocumentMap,
                entities_1.OpportunityFinalNegotiation,
                entities_1.OpportunityFinalNegotiationSharingDetail,
                entities_1.OpportunityFinalNegotiationQcrVariation,
                entities_1.OpportunityFinalNegotiationServiceLevelAgreement,
                entities_1.OpportunityFinalNegotiationQuoteDocuments,
                entities_1.OpportunityFinalNegotiationQuoteCoverDetail,
                entities_1.OpportunityPlacementSlipGeneration,
                entities_1.OpportunityPlacementSlipTpaMap,
                entities_1.OpportunityPlacementSlipInsurerMap,
                entities_1.OpportunityPlacementSlipSharingDetail,
                entities_1.OpportunityPlacementSlipCDDetail,
                entities_1.OpportunityPlacementSlipCoverDetail,
                entities_1.OpportunityQuoteCoverDetail,
                entities_1.OpportunityQuoteTaxMap,
                entities_1.OpportunityQuoteDocumentMap,
                entities_1.OpportunityQuote,
                entities_1.OpportunityBrokingSlipActivityDocumentMap,
                entities_1.OpportunityContactMap,
                entities_1.OpportunityPlacementSlipInstallementDetail,
                entities_1.CompanyContactMap,
            ]),
            address_module_1.AddressModule,
            jwt_1.JwtModule,
            look_up_module_1.LookUpModule,
            employee_module_1.EmployeeModule,
            task_module_1.TaskModule,
            meeting_module_1.MeetingModule,
        ],
        providers: [
            opportunity_service_1.OpportunityService,
            opportunity_repository_1.OpportunityRepository,
            auth_guard_1.AuthGuard,
            role_guard_1.RolesGuard,
            entity_service_utils_1.EntityService,
            notification_utils_1.NotificationUtils,
            lookup_validation_1.LookUpValidationService,
            scope_utils_1.ScopeService,
        ],
        controllers: [opportunity_controller_1.OpportunityController],
    })
], OpportunityModule);
